export default __webpack_public_path__ + "images/eh-8c8b27438e64065d85428af7cefbba6d.svg";